export default __webpack_public_path__ + "static/media/word-frequency-app.bf3fe4bd.png";